module.exports = __webpack_public_path__ + "img/congressov2.af14333c.png";